export default "__VITE_ASSET__dce6d829__"